import $ from "jquery";
import wp from "wp";
import { idx, waitObject } from "@devowl-wp/react-utils";
import { applyUploaderAddRules } from "./uploader.js";
import { createRecursiveUploadProBox, fixAddFileToSkipHiddenFiles, getActiveRmlFolderFromBrowser, getNodeId } from "./uploaderHelpers.js";
import { afterUpload, getActiveTreeStore, renderUploadNotification, showMessage } from "./uploadNotification.js";
import { BROWSER_SELECTOR } from "../backbone/mediaLibraryShared.js";
import { dataUriToBlob } from "../utils/dataUri.js";
let wpUploaderPatchApplied = false;
let wpUploaderSuccessPatched = false;
function bindWpUploaderInstance(wpUploader) {
    const plupload = wpUploader.uploader;
    if (!plupload || plupload.__rmlBound) {
        return;
    }
    plupload.__rmlBound = true;
    wpUploader.__rmlBound = true;
    fixAddFileToSkipHiddenFiles(plupload);
    plupload.bind("FileFiltered", (...filteredArgs)=>{
        const file = filteredArgs[1];
        file.rmlFolderNode = getNodeId();
    });
    plupload.bind("FilesAdded", (...addedArgs)=>{
        const up = addedArgs[0];
        const { files } = up;
        files.forEach((file)=>{
            const uploadFile = file;
            const source = uploadFile.getSource();
            let relativePath = null;
            if (process.env.PLUGIN_CTX === "pro") {
            /* Silence is golden... Until you have PRO Version! */ }
            const { attachment: { cid }, name, percent, loaded, size, rmlFolderNode } = uploadFile;
            const previewObj = {
                cid,
                name,
                percent,
                loaded,
                size,
                node: rmlFolderNode,
                relativePath
            };
            if (!rmlFolderNode) {
                return;
            }
            const activeStore = getActiveTreeStore();
            applyUploaderAddRules(previewObj, uploadFile, rmlFolderNode, activeStore);
            const upload = uploadFile.rmlUpload = activeStore.addUploading(previewObj);
            const preloader = new window.mOxie.Image();
            preloader.onload = ()=>{
                preloader.downsize(89, 89);
                let finalUrl;
                try {
                    finalUrl = preloader.getAsDataURL();
                    finalUrl = dataUriToBlob(finalUrl);
                    finalUrl = window.URL.createObjectURL(finalUrl);
                    finalUrl && upload.setter((u)=>u.previewSrc = finalUrl);
                } catch  {
                // Silence is golden.
                }
            };
            preloader.load(source);
        });
        showMessage(up);
    });
    plupload.bind("BeforeUpload", (...beforeUploadArgs)=>{
        const up = beforeUploadArgs[0];
        const file = beforeUploadArgs[1];
        const { multipart_params } = up.settings;
        const { relativePath } = file.getSource();
        const hasRelativePath = relativePath?.split("/").length > 2;
        let rmlFolderNode = file.rmlFolderNode;
        delete multipart_params.rmlCreateFolder;
        delete multipart_params.rmlFolder;
        !rmlFolderNode && (rmlFolderNode = getNodeId());
        if (rmlFolderNode && !isNaN(+rmlFolderNode.id)) {
            multipart_params.rmlFolder = rmlFolderNode.id;
        }
        if (hasRelativePath) {
            if (process.env.PLUGIN_CTX === "pro") {
            /* Silence is golden... Until you have PRO Version! */ } else {
                createRecursiveUploadProBox();
            }
        }
    });
    plupload.bind("UploadProgress", (...progressArgs)=>{
        const { total } = progressArgs[0];
        const { rmlUpload, percent, loaded } = progressArgs[1];
        rmlUpload?.setter((u)=>{
            u.percent = percent;
            u.loaded = loaded;
        });
        getActiveTreeStore().setUploadTotal(total);
        renderUploadNotification();
    });
    plupload.bind("UploadComplete", afterUpload);
}
function resolveWpUploaderFromBrowser(backboneView) {
    return backboneView?.controller?.uploader?.uploader ?? backboneView?.uploader?.uploader;
}
function scanAndBindExistingUploaders() {
    $(BROWSER_SELECTOR).each(function() {
        const backboneView = $(this).data("backboneView");
        const wpUploader = resolveWpUploaderFromBrowser(backboneView);
        wpUploader && bindWpUploaderInstance(wpUploader);
    });
}
function applyWpUploaderPatch() {
    const WpUploader = window.wp?.Uploader ?? wp.Uploader;
    if (!idx(window, (w)=>w.wp.media) || !WpUploader?.prototype) {
        return false;
    }
    if (!wpUploaderPatchApplied) {
        wpUploaderPatchApplied = true;
        const oldP = WpUploader.prototype;
        const oldInit = oldP.init;
        oldP.init = function(...initArgs) {
            oldInit.apply(this, initArgs);
            bindWpUploaderInstance(this);
        };
    }
    if (!wpUploaderSuccessPatched) {
        wpUploaderSuccessPatched = true;
        const oldP = WpUploader.prototype;
        const oldSucess = oldP.success;
        oldP.success = function(...successArgs) {
            const file_attachment = successArgs[0];
            oldSucess.apply(this, [
                file_attachment,
                ...successArgs
            ]);
            const activeStore = getActiveTreeStore();
            activeStore.removeUploading(file_attachment.cid);
            const uploadId = file_attachment.get("rmlFolderId");
            activeStore.addFoldersNeedsRefresh(uploadId);
            activeStore.addFoldersNeedsRefresh("all");
            const rmlGalleryOrder = file_attachment.get("rmlGalleryOrder");
            const at = rmlGalleryOrder === -1 ? 0 : rmlGalleryOrder;
            $(BROWSER_SELECTOR).each(function() {
                const backboneView = $(this).data("backboneView");
                if (backboneView) {
                    const { controller: { rmlMediaBridge: bridge, rmlTreeStore: browserStore } } = backboneView;
                    const activeNode = getActiveRmlFolderFromBrowser(backboneView) ?? browserStore?.selectedId ?? activeStore.selectedId ?? "";
                    const shouldAddToGrid = activeNode === "all" || uploadId == activeNode || activeNode === "" || activeNode === undefined || browserStore?.selectedId == uploadId || activeStore.selectedId == uploadId;
                    if (shouldAddToGrid) {
                        // WP Toolbar.Select mutates frame.options.button; a second toolbar.render() drops the select label.
                        backboneView.collection.add(file_attachment, {
                            at: activeNode === "" ? 0 : at
                        });
                    }
                    if (bridge && activeStore.foldersNeedsRefresh.indexOf(activeNode) > -1) {
                        bridge.reloadCurrentFolder();
                    }
                }
            });
        };
    }
    scanAndBindExistingUploaders();
    return true;
}
const WP_UPLOADER_POLL_MS = 50;
const WP_UPLOADER_MAX_TRIES = 400;
let wpUploaderWait;
function getWpUploaderConstructor() {
    const WpUploader = window.wp?.Uploader ?? wp.Uploader;
    if (!idx(window, (w)=>w.wp.media) || !WpUploader?.prototype) {
        return undefined;
    }
    return WpUploader;
}
function scheduleWpUploaderPatch() {
    if (applyWpUploaderPatch()) {
        return;
    }
    if (wpUploaderWait) {
        return;
    }
    wpUploaderWait = waitObject(getWpUploaderConstructor, WP_UPLOADER_POLL_MS, WP_UPLOADER_MAX_TRIES).then((WpUploader)=>{
        if (WpUploader) {
            applyWpUploaderPatch();
        }
    }).finally(()=>{
        wpUploaderWait = undefined;
    });
}
export { scheduleWpUploaderPatch };
